import { Link } from "react-router-dom";

const LEGAL = [
  ["Privacy Policy", "/privacy"],
  ["Terms of Service", "/terms"],
  ["Cookie Policy", "/cookies"],
  ["Disclaimer", "/disclaimer"],
];

const NAV = [
  ["Matches", "/matches"],
  ["Competitions", "/competitions"],
  ["Teams", "/teams"],
  ["News", "/news"],
  ["Transfers", "/transfers"],
  ["Compare", "/compare"],
  ["Games", "/games"],
  ["Community", "/community"],
];

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-12 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row">
        <div>
          <div className="flex items-center gap-2">
            <img src="/soccer-favicon.png" alt="Soccer Bros" className="h-7 w-7 object-contain" />
            <span className="font-display text-lg font-black uppercase tracking-tight">Soccer <span className="text-volt">Bros</span></span>
          </div>
          <p className="mt-2 max-w-md text-sm text-slate-500">
            The all-in-one soccer portal - live scores, deep stats, expected goals and the transfer market in one place.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Footer">
          {NAV.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`footer-nav-${to.slice(1)}`}
              className="text-sm font-semibold text-slate-500 transition-colors duration-200 hover:text-ink">
              {label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-8 flex flex-col gap-4 border-t border-slate-100 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} Soccer Bros. Built for fans, analysts, scouts & bettors.</p>
        <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Legal">
          {LEGAL.map(([label, to]) => (
            <Link key={to} to={to} rel="nofollow" data-testid={`footer-legal-${to.slice(1)}`}
              className="text-xs font-semibold text-slate-400 transition-colors duration-200 hover:text-ink">
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  </footer>
);
